import Form from '../../../../display/forms/FormElements'

import Organization from '../../../../things/Organization'

import api from '../../../../configs/api'

import getExistingSuggestions from '../../../../things/getExistingSuggestions'

const elements =
[
    {
        type  : Form.SEARCH_SELECTOR ,
        path  : api.organizations.url ,
        clazz : Organization,
        disabledSuggestions : getExistingSuggestions({ member:'department' , include:true }) ,
        init  :
        {
            id        : 'value',
            key       : 'value',
            label     : 'Organisation',
            autoFocus : false,
            fullWidth : true,
            margin    : 'normal',
            required  : true,
            type      : 'search',
            variant   : 'outlined'
        },
        selector : { i18n :
        {
            empty       : 'Aucune organisation disponible.' ,
            title       : 'Sélectionner une organisation',
            description : 'Veuillez sélectionner une organisation ci-dessous.' ,
        }}
    }
];

const department =
{
    add :
    {
        elements,
        agree       : 'Ajouter' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez sélectionner une organisation en cliquant ci-dessous.' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en  cours...' ,
        success     : 'Ajout du nouveau département réussi!' ,
        title       : 'Ajouter un département'
    },
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer ce département:' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer le département ?'
    },
    title    : 'Départements' ,
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Éditer" ,
        remove : "Supprimer"
    }
};

export default department ;